/* eslint-disable no-undef */
import React, { useState, useEffect, useContext } from 'react';
import { useSelector } from 'react-redux';

import API from 'constants/api';
import { SPECTRUM } from 'constants/predicates';
import { actionError } from 'helpers/actionHelpers';
import LocaleContext from 'constants/localization';
import LocalizedStrings from 'react-localization';

import LiteralEdit from 'field/edit/LiteralEdit';

// SPEC-40
// fetch generated sub number from API on acquisition select
const SubNumberEdit = ({ field, actionError }) => {
  const [error, setError] = useState(null);
  const LS = useContext(LocaleContext);
  localizedStrings.setLanguage(LS.getLanguage());

  const acquisition = useSelector(state => state.field.fields[SPECTRUM.OBJECT_ACQUISITION_INFORMATION]);
  const specifier = useSelector(state => state.field.fields[SPECTRUM.SUB_NUMBER_SPECIFIER]);
  const uri = useSelector(state => state.object.uri) || '';

  useEffect(() => {
    const acquisitionRemoved = acquisition.values.length === 0 && field.values[0] != '';
    const acquisitionAdded = !field.values[0] && acquisition.values.length > 0;

    field.setDisabled(!acquisition || acquisition.values.length === 0)

    // Clear number input
    if (acquisitionRemoved) {
      field.removeValue(0);
    }
    if (acquisitionAdded) {
      if (uri && uri.includes('template')) {
        generateSubNumber();
      }
    }
  }, [acquisition]);

  useEffect(() => {
    validateUniqueSubNumber(field.values[0]);
  }, [specifier]);

  const generateSubNumber = () => {
    fetch(`${API.IDENTIFIER}/subNumber?acquisition=${acquisition.values[0].uri}`)
      .then(res => res.json())
      .then(res => {
        if (res.subNumber) {
          field.setValue(0, res.subNumber);
        } else if (res.error) {
          throw new Error(res.error);
        }
      })
      .catch(e => actionError(e));
  };

  const validateUniqueSubNumber = (number) => {
    if (acquisition.values.length === 0 ) {
      return;
    }
    const parameters = new URLSearchParams({
      acquisition: acquisition.values[0].uri,
      isUnique: true,
      number,
      object: uri,
      specifier: specifier ? specifier.values[0] : ''
    });

    fetch(`${API.IDENTIFIER}/subNumber/isUnique?${parameters.toString()}`)
      .then(res => res.json())
      .then(res => {
        if (!res.isUnique) {
          setError(localizedStrings.notUnique);
        } else {
          setError(null);
        }
      })
      .catch(e => console.log(e));
  };

  return (
    <div>
      { field.disabled && <p className="text-danger">{localizedStrings.acquisitionNotSelected}</p> }
      <LiteralEdit
        validateInput={validateUniqueSubNumber}
        field={field} />
      { error && <p className="text-danger">{error}</p> }
    </div>
  );
};

const localizedStrings = new LocalizedStrings({
  fi: {
    notUnique: 'Alanumero ja tarkenne on jo käytössä',
    acquisitionNotSelected: 'Valitse hankintaerä'
  },
  en: {
    notUnique: 'Sub number and specifier is already in use',
    acquisitionNotSelected: 'Please select Acquisition first'
  }
});

export default SubNumberEdit;